
export default {
  name: 'AppNumberInput',
  model: {
    event: 'change'
  },
  props: {
    id: { type: String, default: null },
    name: { type: String, default: null },
    value: { type: Number, default: null },
    placeholder: { type: String, default: null },
    unit: { type: String, default: null },
    invalid: { type: Boolean, default: false },
    maxlength: { type: Number, default: null },
    size: {
      type: String,
      default: 'medium',
      validator: v => ['medium', 'large'].includes(v)
    }
  },
  data() {
    return {
      isFocused: false
    };
  },
  methods: {
    sanitizedEmit(event) {
      let sanitized = event.target.value.replace(/[^0-9]/g, '');
      if (this.maxlength && sanitized.length > this.maxlength) {
        sanitized = sanitized.slice(0, this.maxlength);
      }
      event.target.value = sanitized;
      this.$emit(event.type, sanitized === '' ? null : parseInt(sanitized));
    }
  }
};
